import React from 'react'
import { RadioGroup } from '@awazevr/design-system.components.radio-group'
import type { RadioGroupProps }  from '@awazevr/design-system.components.radio-group'

export interface SelectRadioGroupDSProps extends RadioGroupProps {
  label?: string | false;
  isLoading?: boolean;
  loadingText?: string;
}
export function SelectRadioGroupDS ({
  ...props
}: Readonly<SelectRadioGroupDSProps>) {
  return (
    <RadioGroup
      {...props}
    />
  )
}
